import { useContext } from 'react';
import { storefrontInfoContext } from './storefront-info-context';

export function useStorefrontInfo() {
  const storefrontInfo = useContext(storefrontInfoContext);
  if (!storefrontInfo) {
    throw new Error(
      'storefrontInfo value is undefined. Make sure you use the StorefrontInfoProvider before using the context.'
    );
  }
  return storefrontInfo;
}

// Hook to read the raw value of StorefrontInfoContext (even if the provider is not provided).
// Use only when absolutely necessary, current use case is for supporting components/hooks in mf_core that support both X4C and X4EC.
export function useStorefrontInfoContext_UNSAFE() {
  return useContext(storefrontInfoContext);
}
